import { DEFAULT_ORDER_OPTION } from '@/shared/config';
import type { SortOption } from './types';

export const DEFAULT_REMINDER_HISTORY_SORT_OPTION: SortOption = {
  id: `${DEFAULT_ORDER_OPTION.sort}:${DEFAULT_ORDER_OPTION.order}`,
  name: 'Mais recente',
  sort: DEFAULT_ORDER_OPTION.sort,
  order: DEFAULT_ORDER_OPTION.order,
};

const BASE_SORT_OPTIONS: SortOption[] = [
  DEFAULT_REMINDER_HISTORY_SORT_OPTION,
  { id: 'createdAt:asc', name: 'Mais antigo', sort: 'createdAt', order: 'asc' },
  { id: 'message:asc', name: 'Ordem alfabética crescente', sort: 'message', order: 'asc' },
  { id: 'message:desc', name: 'Ordem alfabética decrescente', sort: 'message', order: 'desc' },
];

export const MY_HISTORY_SORT_OPTIONS: SortOption[] = [...BASE_SORT_OPTIONS];

export const GENERAL_HISTORY_SORT_OPTIONS: SortOption[] = [
  ...BASE_SORT_OPTIONS,
  {
    id: 'acknowledgedCount:desc',
    name: 'Do maior para o menor',
    sort: 'acknowledgedCount',
    order: 'desc',
  },
  {
    id: 'acknowledgedCount:asc',
    name: 'Do menor para o maior',
    sort: 'acknowledgedCount',
    order: 'asc',
  },
];
